'use strict';

/**
 *
 */
class Site extends BaseComponent {

	static get defaultState() {
		return $.extend(super.defaultState, {
			basePath: "/",
		});
	};

	constructor(element, state) {
		super(element, state);

		//history
		this.history = [];
		this.currentPath = null;

		//display helpers
		this.scrollSpy = site.scrollSpy = new ScrollSpy();
		this.viewportSpy = site.viewportSpy = new ViewportSpy();

		_.bindAll(this, ['start', '_initRouting', '_onHistoryUpdate','_route', 'checkComponents']);

		return this
	}

	start() {
		return this._initRouting();
	}

	_initRouting() {
		History.Adapter.bind(window, 'statechange', () => this._onHistoryUpdate());
		return this._onHistoryUpdate();
	};

	_onHistoryUpdate() {
		let state = History.getState(),
			path, params,
			hash = state.hash;

		if(hash.indexOf('#') != -1) {
			hash = hash.substring(0, hash.indexOf('#') );
		}

		if(hash.substring(0, this.state.basePath.length) == this.state.basePath){
			hash = hash.substr(this.state.basePath.length);
		}

		if(hash.substr(0,1)=="/"){
			hash = hash.substr(1);
		}

		if(hash.indexOf('?') != -1){
			path = hash.substring(0, hash.indexOf('?'));
			params = hash.substr(hash.indexOf('?')+1);
		} else {
			path = hash;
		}

		if(this.debug) console.log('Site._onHistoryUpdate', hash, path, params);

		this.history.push({path:path,params:params});

		if(this.currentPath != path){
			this.currentPath = path;
			this._route(path,params);
		}

		return this
	}

	/**
	 *
	 * @param path
	 * @param params
	 * @returns {Site}
	 * @private
	 */
	_route(path, params) {
		console.error('Site._route must be overridden');
		return this;
	}

	/**
	 * check markup for components to be initialised
	 * @param parent
	 * @returns {Site}
	 */
	checkComponents(parent = document) {
		if(this.debug) console.log('Site.checkComponents', site.components);

		_.forEach(site.components, (value, key) => {
			value.autoInit(parent);
		});

		return this;
	}
}

/**
 * global site object, used for registration of components and config settings
 * TODO: is there a cleaner way to to provide component registration mechanism?
 * */
if(!_.isObjectLike(site)) var site = window.site = {};
if(!site.components) site.components = [];
if(!site.config) site.config = {};
